var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#report_svg__clip0_61530_7214)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5h-6V15h6v-1.5zM16.5 9.75h-9v1.5h9v-1.5zM11.25 17.25H7.5v1.5h3.75v-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3.75H16.5V3A1.5 1.5 0 0015 1.5H9A1.5 1.5 0 007.5 3v.75H5.25a1.5 1.5 0 00-1.5 1.5V21a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5zM9 3h6v3H9V3zm9.75 18H5.25V5.25H7.5V7.5h9V5.25h2.25V21z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "report_svg__clip0_61530_7214"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgReport;